import { SxProps, Theme } from '@mui/material/styles';
import { useSessionStorage } from 'usehooks-ts';

import { MOBILE_APP_CLUB_CODE, ValidClubCode } from '../constants/mobileApp';
import { enableMobileWebviewUi } from './useGetFeatureFlags';

const buttonRadius: Partial<Record<ValidClubCode, string | number>> = {
  '005': '30px',
};

const useClubButtonStyles = (): SxProps<Theme> => {
  const [clubCode] = useSessionStorage(MOBILE_APP_CLUB_CODE, '');

  if (!enableMobileWebviewUi) {
    return {};
  }

  const radius = buttonRadius[clubCode as ValidClubCode];

  return radius ? { borderRadius: radius } : {};
};

export default useClubButtonStyles;
